export default __webpack_public_path__ + "static/media/bar.f089ad0f.png";